import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const terms = [
  {
    title: "1. Eligibility",
    content: [
      "To use our Services, you must:",
      "• Be at least 13 years old or the legal age of majority in your jurisdiction.",
      "• Have the legal capacity to enter into a binding contract.",
      "• Agree to provide accurate and complete information during checkout or login."
    ]
  },
  {
    title: "2. Service Scope",
    content: [
      "HPHT Vending provides a digital interface for:",
      "• Browsing and purchasing products via vending machines.",
      "• Making cashless payments via Razorpay.",
      "• Unlocking compartments using QR codes after successful payment.",
      "Machine availability, pricing, and inventory may vary by location and time."
    ]
  },
  {
    title: "3. Orders and Payments",
    content: [
      "• Orders are confirmed only after successful Razorpay payment.",
      "• Prices are displayed in MYR and are inclusive of applicable taxes unless otherwise stated.",
      "• All transactions are final. For refund-related inquiries, refer to our Refund Policy."
    ]
  },
  {
    title: "4. QR Code and Access",
    content: [
      "• After successful payment, a QR code is generated to unlock your selected product compartment.",
      "• This QR code is valid only within a limited time window (e.g., 2 hours).",
      "• Unauthorized duplication, sharing, or misuse of the QR code is strictly prohibited."
    ]
  },
  {
    title: "5. Product Availability",
    content: [
      "• Product availability is on a first-come-first-serve basis.",
      "• In rare cases, system errors may allow purchases of out-of-stock items. If this occurs, you may contact us for a refund or substitution."
    ]
  },
  {
    title: "6. Account and Access",
    content: [
      "• Some vending machines require customer login and are restricted to authorized users only.",
      "• You are responsible for maintaining the confidentiality of your login credentials.",
      "• You agree not to access any private machine or dashboard you are not authorized for."
    ]
  },
  {
    title: "7. Returns and Refunds",
    content: [
      "• All sales are final. No returns are accepted unless the product is defective or undispensed.",
      "• If your item was not dispensed after payment, contact us with your session ID and product.",
      "• Refunds, if approved, will be processed via Razorpay to the original payment method.",
      "• Please refer to our separate Refund Policy for more information."
    ]
  },
  {
    title: "8. Use Restrictions",
    content: [
      "You agree not to:",
      "• Tamper with, damage, or misuse the vending machines or their software.",
      "• Bypass any authentication mechanisms.",
      "• Use the system for any illegal, unauthorized, or harmful activity.",
      "We reserve the right to suspend or ban users who violate these terms."
    ]
  },
  {
    title: "9. Intellectual Property",
    content: [
      "• All content on the website, machine interface, and branding materials are the property of HPHT Technology.",
      "• You may not use, copy, or redistribute without permission."
    ]
  },
  {
    title: "10. Limitation of Liability",
    content: [
      "To the maximum extent permitted by law:",
      "• We are not liable for indirect, incidental, or consequential damages.",
      "• We are not responsible for losses due to user error, mis-scanning, or expired QR codes."
    ]
  },
  {
    title: "11. Changes to Terms",
    content: [
      "• We may update these Terms at any time. Continued use of the Services after changes constitutes acceptance of the updated terms."
    ]
  },
  {
    title: "12. Governing Law",
    content: [
      "• These Terms are governed by the laws of Malaysia.",
      "• Any disputes shall be handled in the courts of Kuala Lumpur."
    ]
  }
];

const TermsAndConditions = () => (
  <Container sx={{ mt: 4, mb: 6 }}>
    <Typography variant="h4" gutterBottom>
      Terms & Conditions
    </Typography>

    <Typography variant="subtitle2" gutterBottom color="text.secondary">
      Last updated: 2025-09-12
    </Typography>

    <Typography variant="body1" paragraph>
      Welcome to HPHT Vending, operated by HPHT Technology ("we", "us", or "our").
      By accessing or using our vending machines, web applications, and related services (collectively, the "Services"),
      you agree to be bound by the following Terms and Conditions.
    </Typography>

    <Typography variant="body1" paragraph>
      Please read these terms carefully. If you do not agree to these terms, do not use our Services.
    </Typography>

    {terms.map((section, index) => (
      <Box key={index} sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          {section.title}
        </Typography>
        {section.content.map((line, i) => (
          <Typography key={i} variant="body1" paragraph sx={{ pl: 2 }}>
            {line}
          </Typography>
        ))}
        {index < terms.length - 1 && <Divider sx={{ mt: 2 }} />}
      </Box>
    ))}
  </Container>
);

export default TermsAndConditions;
